import React from 'react'
import { Link } from 'react-router-dom'

const NextBtn = ({ nextLabel, nextLink }) => {
    return (
        <Link className="btn question-btn" to={ nextLink }>
            <p>{ nextLabel }</p> 
            <svg className="next" width="30px" height="14px" viewBox="0 0 30 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <path d="M1,6 L17,6 L17,1.61803399 C17,1.06574924 17.4477153,0.618033989 18,0.618033989 C18.1552451,0.618033989 18.3083582,0.654179081 18.4472136,0.723606798 L29.2111456,6.10557281 C29.7051241,6.35256206 29.9053485,6.9532351 29.6583592,7.4472136 C29.5615955,7.640741 29.404673,7.79766349 29.2111456,7.89442719 L18.4472136,13.2763932 C17.9532351,13.5233825 17.3525621,13.3231581 17.1055728,12.8291796 C17.0361451,12.6903242 17,12.5372111 17,12.381966 L17,8 L1,8 C0.44771525,8 6.76353751e-17,7.55228475 0,7 C-6.76353751e-17,6.44771525 0.44771525,6 1,6 Z"></path>
            </svg>
        </Link>
    )
}

export default NextBtn


// WEBPACK FOOTER //
// ./src/components/NextBtn.js